import type { PostTagCategory } from "./danbooru-tag-types"

/**
 * Tag types from an e621-style post (e621, e926, e6AI), which arrives with its tags already grouped by type
 * (`tags.artist`, `tags.character`, ...). Species and lore tags stay general: the viewer has no group for them. Shared by the server
 * mapper (lib/booru-sources/booru-api/e621.ts) and the browser one (lib/e621-client.ts) so both give the same result.
 */
export function e621TagCategories(tags: Record<string, unknown>, allTags: string[]): Record<string, PostTagCategory> {
  const categories: Record<string, PostTagCategory> = {}
  for (const tag of allTags) categories[tag] = "general"
  for (const [field, category] of [["artist", "artist"], ["character", "character"], ["copyright", "copyright"], ["meta", "meta"]] as const) {
    const group = tags[field]
    if (Array.isArray(group)) for (const tag of group) if (typeof tag === "string" && tag) categories[tag] = category
  }
  return categories
}
